import { createFileRoute } from '@tanstack/react-router'
import { PendingEvaluationsTab } from '~/components/routes/visioReviews/PendingEvaluationsTab'
import { VisioReviewsLayout } from '~/components/routes/visioReviews/VisioReviewsLayout'
import {
  useVisioReviewsPeriod,
  visioReviewsSearchSchema,
} from '~/components/routes/visioReviews/search'
import { VISIO_REVIEWS_TAB_PERMISSIONS } from '~/components/routes/visioReviews/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/visio-reviews/evaluation')({
  staticData: {
    permission: VISIO_REVIEWS_TAB_PERMISSIONS.evaluation,
  },
  validateSearch: visioReviewsSearchSchema,
  component: VisioReviewsEvaluationPage,
})
withRoutePermissions(Route)

function VisioReviewsEvaluationPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const { dateRange, preset } = useVisioReviewsPeriod(search)

  return (
    <VisioReviewsLayout
      activeTab="evaluation"
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    >
      <PendingEvaluationsTab dateRange={dateRange} preset={preset} />
    </VisioReviewsLayout>
  )
}
